export default class AuthActions{
    static AUTH_REQUEST:string = "AUTH_REQUEST"
    static AUTH_SUCCESS:string = "AUTH_SUCCESS"
    static AUTH_ERROR:string = "AUTH_ERROR"
    static AUTH_LOGOUT:string = "AUTH_LOGOUT"
}